module.exports = __webpack_public_path__ + "img/Slide11.4586180a.png";